export default "__VITE_ASSET__26964cda__"